import axios from 'axios';
import { DO_NOT_CONTACT, ADD_DNC_COMMENTS, GET_ERRORS, RESET_DNC_DATA } from './types';

const pellaAPIURL = process.env.GATSBY_PELLA_API;

const config = {
	headers: {
		Authorization: 'bearer ' + process.env.GATSBY_PELLA_RTA_API_TOKEN,
	},
};

export const submitDNC = (customerData) => (dispatch) => {
	axios
		.post(`${pellaAPIURL}/rta/dnc/do-not-contact`, customerData, config)
		.then((res) =>
			dispatch({
				type: DO_NOT_CONTACT,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const addDNCComments = (customerData) => (dispatch) => {
	axios
		.post(`${pellaAPIURL}/rta/dnc/add-comments`, customerData, config)
		.then((res) =>
			dispatch({
				type: ADD_DNC_COMMENTS,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

// Reset dnc data
export const resetDNCCalls = () => ({
	type: RESET_DNC_DATA,
});
